export const kpiData = [
  {name: 'AcceptanceSpeed', translationKey: 'buyer.kpis.acceptanceSpeed', walkme: 'bdashboard-image-vitessedacceptation'},
  {name: 'PaymentSpeed', translationKey: 'buyer.kpis.paymentSpeed', walkme: 'bdashboard-image-vitessedepaiement'},
  {name: 'Refusal', translationKey: 'buyer.kpis.refusal', walkme: 'bdashboard-image-refus'},
  {name: 'NoReaction', translationKey: 'buyer.kpis.noReaction', walkme: 'bdashboard-image-pasdereaction'}
];
